<template>
  <v-navigation-drawer
    class="zoox-component zoox-sidebar"
    dark
    permanent
    mini-variant
    :fixed="!absolute"
    :absolute="absolute"
  >
    <v-list dense>
      <v-list-item class="logo">
        <v-img
          v-if="!hideLogo"
          class="logo-img mb-3"
          @click="$emit('click:logo')"
        ></v-img>
      </v-list-item>
      <z-navigation-drawer-menu-item
        v-for="(menuOption, index) of menuOptions"
        :key="index"
        :title="menuOption.title"
        :icon="menuOption.icon"
        :route="menuOption.route"
        :options="menuOption.options"
        :is-active="menuOption.isActive"
        @click="$emit('click', $event)"
      />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  private: true,
  props: {
    hideLogo: {
      type: Boolean,
      default: false,
    },
    menuOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.zoox-sidebar {
  width: 42px !important;
  background: var(--zoox-navigation-drawer-color) !important;

  .zoox-sidebar-list-options {
    padding-right: 12px;
  }

  .v-btn {
    padding: 0 !important;
    min-width: unset !important;
    width: 100%;
  }

  .v-list-item {
    padding: 0;
    margin-top: -2px;

    &.logo {
      padding: 0 5px;
    }
  }

  .logo-img {
    content: url('../../../../assets/img/logo-branca.svg') !important;
    cursor: pointer;
  }
}
</style>
